import AdminBusinessesContainer from './AdminBusinessesContainer';

export default AdminBusinessesContainer;
